module.exports = __webpack_public_path__ + "static/media/am.1af34491.svg";